import TableAllCurrentSync from './component/TableAllCurrentSync'

export default TableAllCurrentSync